import React, { useContext, useEffect, useState } from 'react';
import { Loader } from 'react-feather';
import ManageTable from '../../../Manage/ManageTable';
import PopupModal from '../../../Manage/PopupModal';
import { Table, Button, Input } from 'reactstrap';
import { getImageURL } from '../../../../snippets/snippets';
import image from '../../../../assets/images/static-image.jpg';
import Rating from 'react-rating';
import { Star } from 'react-feather'
import { ThemeColors } from '@src/utility/context/ThemeColors'
import { AiOutlineLike, AiOutlineDislike } from "react-icons/ai";
import { BsEmojiSmile, BsEmojiNeutral, BsEmojiFrown } from "react-icons/bs";

const SellerReviews = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [modal, setModal] = useState(false);
  const handleModal = () => setModal(!modal);

  const themeColors = useContext(ThemeColors)

  const mockData = [
    {
      id: 1,
      product_name: 'Satisfied',
      serial_number: '#123456789',
      image: '', 
      seller_rating: '5',
      product_review: 'Great seller! Smooth transaction, fast shipping. A pleasure to do business with.',
      action: 'View',
      likes:'12',
      dislikes:'0',
      date:'30/12/2024'
    },
    {
      id: 2,
      product_name: 'Neutral',
      serial_number: '#123456789',
      image: '', 
      seller_rating: '3',
      product_review: 'Great seller! Smooth transaction, fast shipping. A pleasure to do business with.',
      action: 'View',
      likes:'12',
      dislikes:'0',
      date:'30/12/2024'
    },
    {
      id: 3,
      product_name: 'Unsatisfied',
      serial_number: '#123456789',
      image: '', 
      seller_rating: '1',
      product_review: 'Great seller! Smooth transaction, fast shipping. A pleasure to do business with.',
      action: 'View',
      likes:'12',
      dislikes:'0',
      date:'30/12/2024'
    },
  ];

  useEffect(() => {
    // Simulate fetching data
    setTableData(mockData);
    setLoading(false);
  }, []);

  

  const columns = [
    {
      name: 'Satisfaction Level',
      cell: (row) => (
        <div className='d-flex gap-2 flex-column flex-md-row align-items-center'>
          { row.seller_rating == "5" ? <BsEmojiSmile size={25} style={{color:'#FBBD34'}} /> : row.seller_rating == "3" ? <BsEmojiNeutral size={25} style={{color:'#FBBD34'}} /> : row.seller_rating == "1" ? <BsEmojiFrown size={25} style={{color:'#FBBD34'}} /> : '' } 
          <div>
            <div>{row.product_name}</div>
          </div>
        </div>
      ),
      selector: (row) => row.product_name,
      sortable: true,
    },
    {
      name: 'Seller Rating',
      cell: (row) => <span title={row.seller_rating} className="ellipsis">
        <Rating
                                        readonly={true}
                                        initialRating={row.seller_rating}
                                        emptySymbol={<Star size={15} fill='#babfc7' stroke='#babfc7' />}
                                        fullSymbol={<Star size={15} fill={themeColors.colors.warning.main} stroke={themeColors.colors.warning.main} />}
                                        /> 
      </span>,
      selector: (row) => row.seller_rating,
      sortable: true,
    },
    {
        name: 'Seller Review',
        cell: (row) => 
        <>
        <Input type='textarea' value={row.product_review} height={'auto'} disabled='true' />
        </>,
        selector: (row) => row.product_review,
        sortable: true,
        grow: 2
      },
    {
      name: 'Likes',
      cell: (row) => 
        <div style={{display:'flex', flexDirection:'row',alignItems:'center'}}>
          <span title={row.likes == '' ? '0' : row.likes} className="ellipsis">{row.likes == '' ? '0' : row.likes}</span>
          &ensp;
          <AiOutlineLike size={15} />
        </div>,
      selector: (row) => row.likes,
      sortable: true,
    },
    {
      name: 'Dislikes',
      cell: (row) => 
      <div>
        <span title={row.dislikes == '' ? '0' : row.dislikes} className="ellipsis">{row.dislikes == '' ? '0' : row.dislikes}</span>
        &ensp;
        <AiOutlineDislike size={15} />
      </div>,
      selector: (row) => row.dislikes,
      sortable: true,
    },
    {
        name: 'Submission Date',
        cell: (row) => 
            <span title={row.date == '' ? '-' : row.date} className="ellipsis">{row.date == '' ? '-' : row.date}</span>,
          
        selector: (row) => row.date,
        sortable: true,
      },
    {
      name: 'Action',
      cell: (row) => (
        <div color="primary" style={{cursor:'pointer', color:'#41B8E4',}} onClick={() => console.log(`View product: ${row.product_name}`)}>
          {row.action}
        </div>
      ),
      selector: (row) => row.action,
      sortable: true,
      center: true
    }
  ];

  return (
    <>
      <div>
        {loading ? <Loader /> :
          <ManageTable
            name={'Product Reviews'}
            columns={columns}
            setTableData={setTableData}
            tableData={tableData}
          />
        }
      </div>

      <PopupModal
        company_id={''}
        open={modal}
        setModal={setModal}
        handleModal={handleModal}
        name={''}
        tableData={''}
        setTableData={''}
      />
    </>
  );
};

export default SellerReviews;
